import React from 'react';
import Layout from './Layout';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Layout>
          <div className="flex flex-col items-center justify-center min-h-[400px] gap-4" data-testid="error-boundary">
            <AlertTriangle className="w-12 h-12 text-amber-500" />
            <h2 className="text-xl font-semibold text-slate-800">Something went wrong</h2>
            <p className="text-sm text-slate-500 max-w-md text-center">
              {this.state.error?.message || 'An unexpected error occurred. Please try refreshing the page.'}
            </p>
            <Button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
              className="rounded-sm"
              data-testid="error-boundary-reload"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Reload Page
            </Button>
          </div>
        </Layout>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
